import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export const dropHighlightOffset = -1;

export type DropHighlightProps = ComponentProps<'div'> & {
  borderRadius?: number;
};

// biome-ignore lint/plugin: the drop highlight border classes are shared with and without the radius variant
const BASE_CLASS_NAME =
  'pointer-events-none absolute box-border border-[3px] border-transparent transition-colors duration-150 ease-in ads:group-[.hovering-drop]/droppable-item:border-primary group-[.hovering-drop]/droppable-item:border-blue-9 ads:group-[.hovering-drop]/droppable-item:bg-subtle group-[.hovering-drop]/droppable-item:bg-gray-3';

const BASE_CLASS_NAME_WITH_RADIUS = cn(BASE_CLASS_NAME, 'rounded-6');

export const DropHighlight = memo(({ className, style, borderRadius, ...props }: DropHighlightProps) => (
  <div
    className={cn(borderRadius !== undefined ? BASE_CLASS_NAME : BASE_CLASS_NAME_WITH_RADIUS, className)}
    style={{
      borderRadius: borderRadius !== undefined ? borderRadius : undefined,
      bottom: dropHighlightOffset,
      left: dropHighlightOffset,
      right: dropHighlightOffset,
      top: dropHighlightOffset,
      ...style,
    }}
    {...props}
  />
));

DropHighlight.displayName = 'DropHighlight';
